<template>
    <div class="handout-download-link">

        <template v-if="handout.attachment">
            <a href="#"
               @click="download()">{{ handout.label }}</a>
        </template>
        <template v-else>
            <a target="_blank"
               :href="`/yph_pdfs/${handout.pdf}`">{{ handout.label }}</a>
        </template>

    </div>
</template>

<script>

    import Vue from 'vue'

    /**
     * Renders a link to download a Handout - either as a regular link to a PDF (for stock handouts),
     * or as a download button for an attachment (for custom handouts)
     */
    export default Vue.extend({
        name: 'HandoutDownloadLink',
        props: {
            handout: Object
        },
        methods: {
            download () {
                this.$api.downloadAttachment(this.handout.attachment, true)
                    .catch((e) => {
                        this.$utils.handleError(e, 'Could not download file')
                    })
            }
        }
    })
</script>

<style lang="scss">
</style>
